import React from "react";
import {
  AUTH_PREFIX_PATH,
  APP_PREFIX_PATH,
  REGISTER_PREFIX_PATH,
  REGISTER_ENTRY_KEY,
} from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${REGISTER_PREFIX_PATH}/register/${REGISTER_ENTRY_KEY}`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "forgot-password-changePassword",
    path: `${AUTH_PREFIX_PATH}/forgot-password/changePasswords/:token`,
    component: React.lazy(() =>
      import(
        "views/auth-views/authentication/forgot-password/ChangePasswordForm"
      )
    ),
  },
  {
    key: "RendezVous.confirmNanny",
    path: `${AUTH_PREFIX_PATH}/rendez-vous/confirmNanny/:token`,
    component: React.lazy(() => import("views/app-views/rendez-vous/AppointmentConfirm")),
  },
  {
    key: "RendezVous.confirmParent",
    path: `${AUTH_PREFIX_PATH}/rendez-vous/confirmParent/:token`,
    component: React.lazy(() => import("views/app-views/rendez-vous/AppointmentConfirm")),
  },
];

export const protectedRoutes = [
  {
    key: "Dashboards",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "Babysitters",
    path: `${APP_PREFIX_PATH}/nounou/*`,
    component: React.lazy(() => import("views/app-views/nounou")),
  },
  {
    key: "Babysitters.list",
    path: `${APP_PREFIX_PATH}/nounou/liste`,
    component: React.lazy(() => import("views/app-views/nounou/nounouList")),
  },
  {
    key: "Babysitters.add",
    path: `${APP_PREFIX_PATH}/nounou/ajouter`,
    component: React.lazy(() => import("views/app-views/nounou/nounouAdd")),
  },
  {
    key: "Babysitters.edit",
    path: `${APP_PREFIX_PATH}/nounou/modifier/:id `,
    component: React.lazy(() => import("views/app-views/nounou/nounouEdit")),
  },
  {
    key: "User.manageAccount",
    path: `${APP_PREFIX_PATH}/mon_compte/*`,
    component: React.lazy(() => import("views/app-views/account")),
  },
  {
    key: "Users.users",
    path: `${APP_PREFIX_PATH}/utilisateurs/*`,
    component: React.lazy(() => import("views/app-views/users")),
  },
  {
    key: "Users.listUsers",
    path: `${APP_PREFIX_PATH}/utilisateurs/liste`,
    component: React.lazy(() => import("views/app-views/users/usersList")),
  },
  {
    key: "Users.addUsers",
    path: `${APP_PREFIX_PATH}/utilisateurs/ajouter`,
    component: React.lazy(() => import("views/app-views/users/userAdd")),
  },

  {
    key: "BabySitters.profile",
    path: `${APP_PREFIX_PATH}/nounou/profil/:id`,
    component: React.lazy(() => import("views/app-views/nounou/nounouProfile")),
  },

  {
    key: "Parents",
    path: `${APP_PREFIX_PATH}/parent/*`,
    component: React.lazy(() => import("views/app-views/parent")),
  },
  {
    key: "Parents.list",
    path: `${APP_PREFIX_PATH}/parent/liste`,
    component: React.lazy(() => import("views/app-views/parent/parentList")),
  },
  {
    key: "Parents.add",
    path: `${APP_PREFIX_PATH}/parent/ajouter`,
    component: React.lazy(() => import("views/app-views/parent/parentAdd")),
  },
  {
    key: "Parents.edit",
    path: `${APP_PREFIX_PATH}/parent/modifier/:id`,
    component: React.lazy(() => import("views/app-views/parent/parentEdit")),
  },

  {
    key: "Partners",
    path: `${APP_PREFIX_PATH}/partenaires/*`,
    component: React.lazy(() => import("views/app-views/partenaires")),
  },
  {
    key: "Partners.list",
    path: `${APP_PREFIX_PATH}/partenaires/liste`,
    component: React.lazy(() => import("views/app-views/partenaires/partenairesList")),
  },
  {
    key: "Partners.add",
    path: `${APP_PREFIX_PATH}/partenaires/ajouter`,
    component: React.lazy(() => import("views/app-views/partenaires/partenaireAdd")),
  },
  {
    key: "Partners.edit",
    path: `${APP_PREFIX_PATH}/partenaires/modifier/:id`,
    component: React.lazy(() => import("views/app-views/partenaires/partenaireEdit")),
  },
  {
    key: "Plans",
    path: `${APP_PREFIX_PATH}/plans/*`,
    component: React.lazy(() => import("views/app-views/plans")),
  },
  {
    key: "Plans.list",
    path: `${APP_PREFIX_PATH}/plans/liste`,
    component: React.lazy(() => import("views/app-views/plans/plansList")),
  },
  {
    key: "Jobs",
    path: `${APP_PREFIX_PATH}/jobs/*`,
    component: React.lazy(() => import("views/app-views/jobs")),
  },
  {
    key: "Jobs.list",
    path: `${APP_PREFIX_PATH}/jobs/liste`,
    component: React.lazy(() => import("views/app-views/jobs/jobsList")),
  },
  {
    key: "Jobs.add",
    path: `${APP_PREFIX_PATH}/jobs/ajouter`,
    component: React.lazy(() => import("views/app-views/jobs/jobApplicationAdd")),
  },
  {
    key: "Jobs.edit",
    path: `${APP_PREFIX_PATH}/jobs/modifier/:id`,
    component: React.lazy(() => import("views/app-views/jobs/jobApplicationEdit")),
  },
  {
    key: "Jobs.viewOne",
    path: `${APP_PREFIX_PATH}/jobs/details/:id`,
    component: React.lazy(() => import("views/app-views/jobs/jobDetails")),
  },
  // {
  //   key: "paiement",
  //   path: `${APP_PREFIX_PATH}/paiement`,
  //   component: React.lazy(() => import("views/app-views/paiement")),
  // },
  {
    key: "Tasks",
    path: `${APP_PREFIX_PATH}/taches`,
    component: React.lazy(() => import("views/app-views/tasks")),
  },
  {
    key: "RendezVous",
    path: `${APP_PREFIX_PATH}/rendez-vous`,
    component: React.lazy(() => import("views/app-views/rendez-vous")),
  },
 
  {
    key: "Reports.1",
    path: `${APP_PREFIX_PATH}/signalement/gardien/:id`,
    component: React.lazy(() => import("views/app-views/Signalement")),
  },
  {
    key: "Reports.2",
    path: `${APP_PREFIX_PATH}/signalement/parent/:id`,
    component: React.lazy(() => import("views/app-views/Signalement")),
  },
];
